import { Commodity } from '../../models/commodity';
import { createSelector } from '@ngrx/store';

export interface CommodityEditorState {
    id: string | null;
    commodity: Commodity;
    loading: boolean;
    saving: boolean;
}

export const selectCommodityEditorState = (state: any) => state.commodityEditor;

export const selectCommodityEditorId = createSelector(selectCommodityEditorState,
    (state: CommodityEditorState) => state.id);

export const selectCommodityEditorCommodity = createSelector(selectCommodityEditorState,
    (state: CommodityEditorState) => state.commodity);

export const selectCommodityEditorLoading = createSelector(selectCommodityEditorState,
    (state: CommodityEditorState) => state.loading);

export const selectCommodityEditorSaving = createSelector(selectCommodityEditorState,
    (state: CommodityEditorState) => state.saving);

